import React from 'react';

const Text = ({
  width,
  margin,
  fontFamily,
  textDecoration,
  color = 'inherit',
  lineHeight = '1em',
  fontSize = '18px',
  textAlign = 'center',
  text = 'example text',
  fontWeight = 'normal',
  letterSpacing = '1px',
  restOfProps,
}) => (
  <h1
    style={{
      color,
      width,
      margin,
      fontSize,
      textAlign,
      fontWeight,
      fontFamily,
      lineHeight,
      letterSpacing,
      textDecoration,
    }}
    {...restOfProps}
  >
    {text}
  </h1>
);

export default Text;
